import i18n, { i18nNS } from '../../../../../../i18n';
import { usePollContext } from '../../../../Context';

const usePublishedPollTitle = () => {
  const { poll } = usePollContext();

  const pollTitle = poll?.title ?? i18n.t('untitled_poll', { ns: i18nNS.POLL });

  return { pollTitle };
};

export default usePublishedPollTitle;
